export const ADMIN_PDF_EXPORT_ANALYTICS_SOURCE = 'adminPdfExport';
export const STYLESHEET_SUPPORT_DOC_URL =
	'https://support.atlassian.com/confluence-cloud/docs/customize-exports-to-pdf/';
